import React from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export function CadastroUsuario({ modalData }) {
  return (
    <div>
      {modalData?.data?.nome ? (
        <p>
          <b>Nome: </b> {modalData?.data?.nome}
        </p>
      ) : (
        ''
      )}

      {modalData?.data?.cpf ? (
        <p>
          <b>CPF: </b> {modalData?.data?.cpf}
        </p>
      ) : (
        ''
      )}

      {modalData?.data?.email ? (
        <p>
          <b>E-mail: </b> {modalData?.data?.email}
        </p>
      ) : (
        ''
      )}

      {modalData?.data?.telefone ? (
        <p>
          <b>Telefone: </b> {modalData?.data?.telefone}
        </p>
      ) : (
        ''
      )}

      {modalData?.data?.cargo ? (
        <p>
          <b>Cargo: </b> {modalData?.data?.cargo}
        </p>
      ) : (
        ''
      )}

      <p>
        <b>Situação: </b> {modalData?.data?.ativo ? 'Ativo' : 'Inativo'}
      </p>

      {modalData?.data?.dataCriacao ? (
        <p>
          <b>Data de criação: </b>{' '}
          {format(
            new Date(`${modalData?.data?.dataCriacao}`),
            'dd/MM/yyyy - HH:mm:ss',
            {
              locale: ptBR,
            }
          )}
        </p>
      ) : (
        ''
      )}
    </div>
  );
}
